import React from 'react'
import Row, { AutoRow } from 'components/Layout/Row'
import { CurrencyLogo } from 'components/Logo'
import tokens from 'config/constants/tokens'
import { Box, Text } from 'vvs-uikit'
import { usePriceVvsUsdc } from 'state/farms/hooks'
import BigNumber from 'bignumber.js'
import LocalBalance from 'components/LocalBalance'
import useXvvsRate from 'views/xVvs/hooks/useXvvsRate'
import { formatNumber } from 'utils/formatBalance'

interface DepositAmountProps {
  amount: BigNumber
}

const DepositAmount = ({ amount }: DepositAmountProps) => {
  const price = usePriceVvsUsdc()
  const rate = useXvvsRate()

  return (
    <Box>
      <Row justify="space-between" mt={2} mb={1}>
        <AutoRow>
          <CurrencyLogo size="24px" currency={tokens.xvvs} />
          <Text fontSize="20px" ml="8px">
            {formatNumber(amount.toNumber(), 2, 6)}
          </Text>
        </AutoRow>
        <Text fontSize="20px">{tokens.xvvs.symbol}</Text>
      </Row>
      <Text small color="textSubtle">
        <LocalBalance
          fontSize="14px"
          color="textSubtle"
          decimals={2}
          value={amount.multipliedBy(rate?.toSignificant(18)).multipliedBy(price)}
          prefix="~"
          display="inline"
          mr={1}
        />
      </Text>
    </Box>
  )
}

export default DepositAmount
